export const FLEX_ALIGN_PREFIX = "flexAlign";
export const FLEX_JUSTIFY_PREFIX = "flexJustify";

export const SURFACE_COLOR_PREFIX = "surfaceColor";

export const LIMIT_WIDTH_PREFIX = "limitWidth";
